module.exports = __webpack_public_path__ + "img/works.55bc453c.svg";